import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import {
  transformAddressData,
  initialFormValues
} from 'common/components/address/helpers';
import { Layout, Title, FormError } from 'common/components/layout';
import { getDefaultCountryCode } from 'common/helpers/miscHelper';
import { convertStringToInteger } from 'common/helpers/numberHelper';
import SubMenu from 'profile/common/SubMenu';
import { listClubMemberships } from 'redux/clubMemberships/actions';
import { getActiveClubMemberships } from 'redux/clubMemberships/reducers';
import {
  addCustomerAddress,
  listCustomerAddresses
} from 'redux/customerAddresses/actions';

import AddEditForm from './components/AddEditForm';
import ClubMembershipAddressVerify from './components/ClubMembershipAddressVerify';
import { isClubMembershipsWithoutThisAddress } from './helpers';
import { validateAdd } from './validators';

class AddressAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: null,
      addressId: null
    };
  }

  componentDidMount() {
    const { props } = this;
    props.listCustomerAddresses();
    props.listClubMemberships();
  }

  handleClubMembershipAddressVerify = (id) => {
    this.setState({
      modal: 'ClubMembershipAddressVerify',
      addressId: id
    });
  };

  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form);
    const { activeClubMemberships } = this.props;
    let successFunction = () => {
      props.history.push('/profile/address-book');
    };
    if (isClubMembershipsWithoutThisAddress(undefined, activeClubMemberships)) {
      successFunction = (address) => {
        this.handleClubMembershipAddressVerify(address.id);
      };
    }
    props.addCustomerAddress(data, successFunction);
  };

  handleCancel = () => {
    const { props } = this;
    props.history.push('/profile/address-book');
  };

  handleCloseModal = () => {
    const { props } = this;
    this.setState({
      modal: null
    });
    props.history.push('/profile/address-book');
  };

  render() {
    const {
      handleSubmit,
      form,
      change,
      customerAddresses,
      settings,
      initialValues
    } = this.props;
    const { modal, addressId } = this.state;

    let isFirstAddress = false;
    if (customerAddresses.data) {
      const addressArr = Object.keys(customerAddresses.data);
      isFirstAddress = addressArr.length === 0 || false;
    }
    if (!initialValues.countryCode) {
      return (
        <Layout title="Add New Address Book Entry" loading>
          <Title>Your Account</Title>
          <SubMenu />
        </Layout>
      );
    }

    return (
      <Layout title="Add New Address Book Entry" loading>
        <Title>Your Account</Title>
        <SubMenu />
        <div className="c7-account__address-book">
          <h2>Add new address book entry</h2>
          <FormError formName={form} />
          <AddEditForm
            onSubmit={handleSubmit(this.handleSubmit)}
            saveButtonText="Add Address"
            object={initialValues}
            changeFunction={change}
            onCancelFunction={this.handleCancel}
            isFirstAddress={isFirstAddress}
            settings={settings}
          />
        </div>
        {renderModal(modal, this.handleCloseModal, addressId)}
      </Layout>
    );
  }
}

const renderModal = (modal, handleCloseModal, addressId) => {
  switch (modal) {
    case 'ClubMembershipAddressVerify': {
      return (
        <ClubMembershipAddressVerify
          onCloseModal={handleCloseModal}
          addressId={addressId}
        />
      );
    }
    default: {
      return null;
    }
  }
};

const transformData = (values) => {
  const data = transformAddressData(values);
  data.isDefault = values.isDefault || false;
  return data;
};

const validate = (values, ownProps) => {
  const data = transformData(values);
  if (ownProps.settings.data) {
    data.birthDay = values.birthDay && convertStringToInteger(values.birthDay);
    data.birthMonth =
      values.birthMonth && convertStringToInteger(values.birthMonth);
    data.birthYear =
      values.birthYear && convertStringToInteger(values.birthYear);
    const errors = validateAdd(data, ownProps.settings);
    return errors;
  }
  return {};
};

const mapStateToProps = (state) => {
  const customer = state.customer.data;

  const address = {};
  if (customer) {
    if (customer.birthDate) {
      address.birthDay = customer.birthDate.substring(8, 10);
      address.birthMonth = customer.birthDate.substring(5, 7);
      address.birthYear = customer.birthDate.substring(0, 4);
    }
    address.firstName = customer.firstName;
    address.lastName = customer.lastName;
    address.city = customer.city;
    address.stateCode = customer.stateCode;
    address.zipCode = customer.zipCode;
    address.countryCode = customer.countryCode;
    address.phone = customer.phones[0] && customer.phones[0].phone;
  }
  if (!address.countryCode && state.setting && state.setting.data) {
    address.countryCode = getDefaultCountryCode(state.setting);
  }
  return {
    initialValues: initialFormValues(address),
    customer: state.customer,
    customerAddresses: state.customerAddress,
    settings: state.setting,
    activeClubMemberships: getActiveClubMemberships(state.clubMembership)
  };
};

AddressAdd = reduxForm({
  form: 'Add Address',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(AddressAdd);

export default connect(mapStateToProps, {
  addCustomerAddress,
  listCustomerAddresses,
  listClubMemberships
})(AddressAdd);
